import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { v4 as uuidv4 } from 'uuid';

import {
    Box, Divider, Typography, Grid, Button, Container, FormControl, TextField,
    Paper, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress
} from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

function EditarAlmacen() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState({});
    const [almacen, setAlmacen] = useState('');
    const [anaquel, setAnaquel] = useState([]);
    const [nivelesAnaquel, setNivelesAnaquel] = useState('');
    const [posicionesAnaquel, setPosicionesAnaquel] = useState('');
    const [currentAnaquel, setCurrentAnaquel] = useState({});
    const [modalEditAnaquel, setModalEditAnaquel] = useState(false);

    const [loading, setLoading] = useState(true);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (!['Admin', 'Almacen'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Editar Almacén';
    }, [auth])


    const getData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/warehouses/${id}`);
            setAlmacen(res.data.almacen);
            const tmpAnaqueles = res.data.anaqueles.map((x) => {
                return {
                    niveles: x.niveles.length,
                    posiciones: x.posiciones.length,
                    uuid: getUuid()
                }
            })
            setAnaquel(tmpAnaqueles);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    useEffect(() => {
        getData();
    }, [])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getUuid = () => { return uuidv4() };

    const handleAddAnaquel = (e, x) => {
        e.preventDefault();
        x.uuid = getUuid();
        if (x.niveles) {
            setAnaquel(anaquel => [...anaquel, {
                niveles: x.niveles,
                posiciones: x.posiciones,
                uuid: x.uuid
            }]);
        }
        else {
            setAnaquel(anaquel => [...anaquel, {
                posiciones: x.posiciones,
                uuid: x.uuid
            }]);
        }
        setNivelesAnaquel('');
        setPosicionesAnaquel('');
    }

    const handleDeleteAnaquel = (d, r) => {
        if (r < 2) {
            setAnaquel([]);
        } else {
            setAnaquel(anaquel.filter(x => x.uuid !== d)); // filter pie array to remove the one with the key
        }
    }

    const renderEditAnaquel = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEditAnaquel}
                scroll='paper'
                onClose={handleCloseEditAnaquel}>
                <DialogTitle >Editar Anaquel</DialogTitle>
                <DialogContent>
                    {currentAnaquel ?
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Niveles" variant="outlined" value={currentAnaquel.niveles} onChange={(e) => setCurrentAnaquel({ ...currentAnaquel, niveles: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Posiciones" variant="outlined" value={currentAnaquel.posiciones} onChange={(e) => setCurrentAnaquel({ ...currentAnaquel, posiciones: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateAnaquel(currentAnaquel, currentAnaquel.uuid)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEditAnaquel()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleEditAnaquel = (d) => {
        setCurrentAnaquel(d);
        setModalEditAnaquel(true);
    }

    const handleUpdateAnaquel = (d, e) => {
        setModalEditAnaquel(false);
        let tmp = {}
        tmp.uuid = e;
        if (d.niveles)
            if (d.niveles !== '')
                tmp.niveles = d.niveles;
        if (d.posiciones)
            tmp.posiciones = d.posiciones;
        setAnaquel(anaquel.map(r => r.uuid === e ? tmp : r));
    }

    const handleCloseEditAnaquel = () => {
        setModalEditAnaquel(false);
        setCurrentAnaquel({ key: '', value: '' });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const anaqueles = anaquel.map((x) => {
            return {
                niveles: [...Array(Number(x.niveles)).keys()],
                posiciones: [...Array(Number(x.posiciones)).keys()]
            }
        })
        let tmp = {
            almacen: almacen,
            anaqueles: anaqueles
        }

        try {
            const res = await axios.post(`/api/warehouses/${id}`, { warehouse: tmp });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Se creo el almacén', severity: 'success' } });
                setTimeout(() => {
                    navigate('/almacenes/verAlmacenes');
                }, 800);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al crear el almacen, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            {
                loading ?
                    <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                        <CircularProgress size='5em' color='primary' />
                    </Box> :

                    <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                        <Container maxWidth='xl'>
                            <Box className='text-center' >
                                <Typography variant='h5' style={{ fontWeight: 700 }}>Editar Almacén</Typography>
                            </Box>

                            <Button size='small' variant='outlined' onClick={() => navigate('/almacenes/verAlmacenes')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Detalles del almacén' className='text-bold' />
                            </Divider>

                            <Grid container>
                                <Grid item xs={12} md={12}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Nombre del Almacén" variant="outlined" value={almacen} onChange={(e) => setAlmacen(e.target.value)} />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <div>
                                <div>
                                    {anaquel.map((n, i) => (
                                        <Grid container spacing={1} key={i} className='my-1' sx={{ border: '0.5px solid #555', borderRadius: '20px', padding: '4px' }}>
                                            <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography fontWeight={500}>Anaquel &nbsp;<span style={{ fontWeight: '700' }}>{i + 1}</span></Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography fontWeight={700}>{anaquel[i].niveles} &nbsp;<span style={{ fontWeight: '500' }}>Niveles</span></Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography fontWeight={700}>{anaquel[i].posiciones} &nbsp;<span style={{ fontWeight: '500' }}>Posiciones</span></Typography>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Button variant='outlined' color='error' onClick={() => handleDeleteAnaquel(anaquel[i].uuid, anaquel.length)}>Eliminar &nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Button variant='outlined' color='primary' onClick={() => handleEditAnaquel(anaquel[i])}>Editar &nbsp;<i className='fad fa-edit'></i></Button>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </div>
                                <form onSubmit={(e) => handleAddAnaquel(e, { niveles: nivelesAnaquel, posiciones: posicionesAnaquel })}>
                                    <Grid container spacing={3} className='my-2'>
                                        <Grid item xs={12} md={4}>
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField required label="Cantidad de Niveles" variant="outlined" value={nivelesAnaquel} onChange={(e) => setNivelesAnaquel(e.target.value)} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField required label="Cantidad de Posiciones" variant="outlined" value={posicionesAnaquel} onChange={(e) => setPosicionesAnaquel(e.target.value)} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Button variant='outlined' size='large' color='primary' type='submit'>Agregar anaquel &nbsp; <i className="fad fa-plus-circle"></i></Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </div>
                            <Grid container>
                                <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                    <Button variant="contained" color="success" size='large' onClick={(e) => handleSubmit(e)}>Guardar &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                                </Grid>
                            </Grid>

                            <hr></hr>
                        </Container>
                        <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
                    </Paper>
            }

            {renderEditAnaquel()}
        </Container>
    );
}

export default EditarAlmacen;